import { SPI, ActionType, ViewActionTarget, ActionWidget, ActiveRecord, DrawerWidget } from '@kunlun/dependencies';

import { BizAuditRecordViewAction } from '@kunlun/dependencies';

@SPI.ClassFactory(
  ActionWidget.Token({
    actionType: [ActionType.View],
    target: [ViewActionTarget.Inner],
    name: 'BizAuditRecordViewAction'
  })
)
export class CustomBizAuditRecordDialogAction extends BizAuditRecordViewAction {
  initialize(props: any): this {
    super.initialize(props);
    return this;
  }

  protected innerPopup: any | undefined;

  protected createPopupWidget(data: ActiveRecord[]): void {
    const { popupDslDefinition } = this;
    if (!popupDslDefinition) {
      return;
    }
    const contextType = this.action?.contextType;
    let isFetchData = this.isFetchData(data);
    if (isFetchData === undefined && contextType) {
      isFetchData = !this.isNotNeedFetchData(data, contextType);
    }
    const { dslDefinition } = popupDslDefinition;
    dslDefinition.width = '50%';
    const innerPopupWidget: DrawerWidget | undefined = this.metadataSubviewWidget?.createWidget(
      new DrawerWidget(),
      undefined,
      {
        internal: true,
        template: dslDefinition,
        dataSource: isFetchData ? undefined : data,
        mountedVisible: true
      }
    );
    if (innerPopupWidget) {
      innerPopupWidget.on('ok', async () => {
        this.onCloseInnerPopup();
      });
      innerPopupWidget.on('cancel', () => {
        this.onCloseInnerPopup();
      });
      this.innerPopup = innerPopupWidget;
    }
  }
}
